import { useEffect, useState } from 'react';
import { getResourceTypesAutoria, getResourceTypesVideo } from '../../services/calculator/getResourceTypesService.js';

export const useResourceTypes = (category) => {
    const [resourceTypes, setResourceTypes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const loadResourceTypes = async () => {
            try {
                let data = [];
                if (category === 'autoria') {
                    data = await getResourceTypesAutoria();
                } else if (category === 'video') {
                    data = await getResourceTypesVideo();
                } else {
                    throw new Error('Categoría de recurso no soportada');
                }
                setResourceTypes(data);
            } catch {
                setError('Error cargando los recursos.');
            } finally {
                setLoading(false);
            }
        };

        loadResourceTypes();
    }, [category]);

    return {
        resourceTypes,
        loading,
        error
    };
}